import React, { ComponentType, FC, useEffect, useState } from 'react'
import AuthCode from './AuthCode'

const WithAuthCode = <P extends any>(Component: ComponentType<P>): FC<P> => (props) => {
    const isAccessCodeValid = sessionStorage.getItem("isAccessCodeValid") as string
    //if (isAccessCodeValid) {
    //    return <Component {...props} />
    //} else {
    return (
        <>
            <AuthComponent isAccessCodeValid={isAccessCodeValid} Component={Component} {...props} />
        </>
    )
    //}
}

const AuthComponent: React.FC<any> = ({ Component, isAccessCodeValid, ...props }) => {

    const [authCode, setAuthCode] = useState(isAccessCodeValid);

    const [accessValid, setAccessValid] = useState(false)
    const [isLayoutReleased, setIsLayoutReleased] = useState<boolean | null>(null);

    useEffect(() => {
        console.log('authCode')
    }, [])
    // AuthCode is rendered as a SIBLING of Component (not as its children). Passed
    // down as children it landed in DocumentLink's {props.children} slots, which sit
    // inside conditional CustomForm branches that flip during load/auth — so the
    // Modal was unmounted+remounted (replaying its open animation, i.e. "flashing").
    // Rendered here it mounts once at a stable position until accessValid flips.
    // Safe: its contexts (useDocument/useBranding/useAuth/useSSO) are app-level, and
    // AuthCode already renders standalone at the /AuthCode route.
    return <>
        <Component {...props} isAccessCodeValid={accessValid} setIsAccessCodeValid={setAccessValid} authCode={authCode} setAuthCode={setAuthCode} setIsLayoutReleased={setIsLayoutReleased} />
        {isLayoutReleased !== false && !accessValid && <AuthCode authCode={authCode} setAccessValid={setAccessValid} setAuthCode={setAuthCode} location={{
            state: {
                referrer: `${window.location.pathname}${window.location.search}`,
                data: window.location.search,
                href: window.location.href
            }
        }} />
        }
    </>
}
export default WithAuthCode